import React, { useContext, Suspense } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { string, func } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { DataProvider } from '@thd-nucleus/data-sources';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ currentRouteName, currentRouteComponent, timeout }) => {
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path={routes.storesearch.path}>
          <routes.storesearch.component />
        </Route>
        <Route exact path={routes.storedetails.path}>
          <routes.storedetails.component />
        </Route>
        <Route exact path={routes.storedirectory.path}>
          <routes.storedirectory.component />
        </Route>
        <Route exact path={routes.statedirectory.path}>
          <routes.statedirectory.component />
        </Route>
        <Route exact path={routes.homeServices.path}>
          <routes.homeServices.component />
        </Route>
        <Route exact path={routes.rentalServices.path}>
          <routes.rentalServices.component />
        </Route>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  currentRouteName: string,
  currentRouteComponent: func,
  timeout: string,
};

App.defaultProps = {
  currentRouteName: null,
  currentRouteComponent: null,
  timeout: null,
};
